export enum NodeType {
    Response = "RESPUESTA",
    Action = "ACCION",
    Question = "PREGUNTA",
    FAQ = "FAQ"

}